<template>
  <div class="imageWrapper">
    <img
      v-if="image"
      class="CardImage image"
      :class="image.class"
      :style="image.style"
      :src="image.url"/>
  </div>
</template>

<script>
export default {
  name: 'card-image',
  props: {
    image: {
      type: Object
    }
  }
}
</script>

<style lang="scss">
  .imageWrapper img:hover, .imageWrapper img:focus {
    transform: rotate(0.5deg) scale(.99);
  }
</style>
